if (!customElements.get("m-ba-story-slider-umt")) {
  class MBAStorySliderUMT extends HTMLElement {
    constructor() {
      super();
      this.handleBlockSelect = this.handleBlockSelect.bind(this);
    }

    connectedCallback() {
      this.track = this.querySelector("[data-track]");
      this.prevBtn = this.querySelector("[data-nav-prev]");
      this.nextBtn = this.querySelector("[data-nav-next]");

      if (this.prevBtn) {
        this.prevBtn.addEventListener("click", () => this.scrollTrack(-1));
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener("click", () => this.scrollTrack(1));
      }

      document.addEventListener("shopify:block:select", this.handleBlockSelect);
    }

    disconnectedCallback() {
      document.removeEventListener("shopify:block:select", this.handleBlockSelect);
    }

    scrollTrack(direction) {
      if (!this.track) return;

      const firstCard = this.querySelector("[data-card]");
      const gap = this.getCardGap();
      const cardWidth = firstCard ? firstCard.getBoundingClientRect().width : 300;
      const amount = cardWidth + gap;

      this.track.scrollBy({
        left: direction * amount,
        behavior: "smooth"  
      });
    }

    getCardGap() {
      if (!this.track) return 0;
      const styles = window.getComputedStyle(this.track);
      return parseFloat(styles.columnGap || styles.gap || 0);
    }

    handleBlockSelect(event) {
      const block = event.target;
      if (!block || !this.contains(block) || !this.track) return;

      const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

      block.scrollIntoView({
        behavior: prefersReducedMotion ? "auto" : "smooth",
        block: "nearest",
        inline: "center"
      });
    }
  }

  customElements.define("m-ba-story-slider-umt", MBAStorySliderUMT);
}